import ActionIcons from "../actionIcons";
export const getHeaderConfig = (loadData) => [
  {
    label: "Email",
    id: "email",
  },
  {
    label: "Actions",
    id: "actions",
    render: (data) => {
      return (
        <ActionIcons loadData={loadData} type="mailing list" id={data.id} />
      );
    },
  },
];
